// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__B49bz","isFullHeight":"style_isFullHeight__iVDU_","layout-body":"style_layout-body__nldyh"};